import { PAGE_TITLES } from "@miplatform/constants";
import { HomeDetails, Homes, HomesList } from "../../views";

export const homesRoutes = [
  {
    path: "/homes",
    name: "Homes",
    element: <Homes />,
    handle: { title: PAGE_TITLES.HOMES },
  },
  {
    path: "/homes/list",
    name: "Homes List",
    element: <HomesList />,
    handle: { title: PAGE_TITLES.HOMES_LIST },
  },
  {
    path: "/homes/:id/:tab?",
    name: "HomeDetails",
    element: <HomeDetails />,
    handle: { title: PAGE_TITLES.HOME },
  },
];
